export default "__VITE_ASSET__BRHc5lsQ__"